var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostpone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    width: 20,
    height: 21,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.485a9.042 9.042 0 018.56-9L7.824 1.412A.492.492 0 018.34.575l3.279 2.021a.492.492 0 01.109.746l-2.295 2.57a.492.492 0 11-.733-.655l1.607-1.8h-.258a8.033 8.033 0 108.066 8.033 8.489 8.489 0 00-3.588-6.855.491.491 0 11.552-.813 9.5 9.5 0 014.021 7.663 9.05 9.05 0 01-18.1 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.984 15.735l-3.267-3.92a.489.489 0 01-.119-.244v-.01a.478.478 0 01-.007-.085v-4.58a.492.492 0 01.984 0v4.408l3.164 3.8a.491.491 0 11-.755.629z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .502h20v20H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostpone);
export default __webpack_public_path__ + "static/media/Postpone.a0bc260eaaec266ebb3b0b252b69f8a8.svg";
export { ForwardRef as ReactComponent };